import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { VisualSystemSection } from '../components/VisualSystemSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BuyBoxSection } from '../components/BuyBoxSection';
import { BonusesSection } from '../components/BonusesSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { FAQSection } from '../components/FAQSection';
import { StickyFooter } from '../components/StickyFooter';
// ============================================================
// VARIANTE B — Modifica esta página para tu A/B test
// La variante A está en pages/LandingPage.tsx (ruta "/")
// Esta variante B está en la ruta "/b"
// ============================================================
export function LandingPageB() {
  return <main className="min-h-screen bg-white" data-id="element-254">
      <HeroSection data-id="element-255" />
      <PainPointsSection data-id="element-256" />
      <WhatsInsideSection data-id="element-257" />
      <VisualSystemSection data-id="element-258" />
      <BenefitsSection data-id="element-259" />
      <BuyBoxSection data-id="element-260" />
      <BonusesSection data-id="element-261" />
      <ReviewsSection data-id="element-262" />
      <FAQSection data-id="element-263" />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4 text-center" data-id="element-264">
        <div className="max-w-4xl mx-auto" data-id="element-265">
          <p className="font-bold text-lg mb-3" data-id="element-266">MegaKit Lectura Feliz</p>
          <p className="text-gray-400 text-sm mb-6" data-id="element-267">
            Ayudando a miles de niños a descubrir el amor por la lectura.
          </p>
          <div className="text-xs text-gray-600" data-id="element-268">
            &copy; {new Date().getFullYear()} MegaKit Lectura Feliz. Todos los
            derechos reservados.
            <div className="mt-2 space-x-4" data-id="element-269">
              <a href="#" className="hover:text-white transition" data-id="element-270">
                Términos
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-271">
                Privacidad
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-272">
                Contacto
              </a>
            </div>
          </div>
        </div>
      </footer>

      <StickyFooter data-id="element-273" />
    </main>;
}